import dayjs from 'dayjs'
import 'dayjs/locale/es'
import 'dayjs/locale/hi'
import 'dayjs/locale/zh-cn'
import isToday from 'dayjs/plugin/isToday'

dayjs.extend(isToday)

export default dayjs
